import axios from 'axios'

const baseUrl = 'https://mom-api.estudio34.com';
// const baseUrl = 'http://nb:7000';
axios.defaults.baseURL = baseUrl;
axios.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8'
let userdata = JSON.parse( localStorage.getItem('userdata') ) || false

//HTTP BASIC AUTH
// axios.defaults.headers.common['Authorization'] = 'Basic c2ZtdGVzdDpub2luZGV4'


if ( userdata ) {
  axios.defaults.headers.common['X-User-Email'] = userdata['email']
  axios.defaults.headers.common['X-User-Token'] = userdata['token']
}

function reset_axios() {
  let userdata = JSON.parse( localStorage.getItem('userdata') ) || false

  if ( userdata ) {
    axios.defaults.headers.common['X-User-Email'] = userdata['email']
    axios.defaults.headers.common['X-User-Token'] = userdata['token']
  } else {
    delete axios.defaults.headers.common['X-User-Email']
    delete axios.defaults.headers.common['X-User-Token']
  }
}

export { axios, reset_axios, baseUrl }



// WEBPACK FOOTER //
// ./src/js/services/index.js